import React, { useState, useEffect } from 'react';
import { WEDDING_DATE, IMAGES } from '../constants';
import { TimeLeft } from '../types';

export const Countdown: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft | null>(null);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = +WEDDING_DATE - +new Date();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    };

    const timer = setInterval(calculateTimeLeft, 1000);
    calculateTimeLeft();

    return () => clearInterval(timer);
  }, []);

  if (!timeLeft) return null;

  const items = [
    { label: 'DAYS', value: timeLeft.days },
    { label: 'HOURS', value: timeLeft.hours },
    { label: 'MINUTES', value: timeLeft.minutes },
    { label: 'SECONDS', value: timeLeft.seconds },
  ];

  return (
    <div className="relative w-full pt-12 pb-0 bg-black overflow-hidden">
      <div className="max-w-xl mx-auto px-6">
        {/* Container for Image and Timer */}
        <div className="relative group overflow-hidden rounded-[2.5rem] shadow-2xl transition-all duration-500 hover:shadow-black/40 border border-white/10">
          
          {/* Background Image - Black & White with increased height */}
          <img 
            src={IMAGES.countdown} 
            alt="Heather and Jordan" 
            className="w-full h-[450px] md:h-[650px] object-cover object-center grayscale transition-transform duration-700 group-hover:scale-105 opacity-80"
          />
          
          {/* Centered Semi-Transparent Bar across the middle */}
          <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 bg-black/60 backdrop-blur-md py-3 md:py-6 border-y border-white/5">
            <div className="grid grid-cols-4 gap-1 md:gap-4 max-w-lg mx-auto px-4">
              {items.map((item) => (
                <div key={item.label} className="text-center">
                  <div className="relative mb-0.5">
                    <span className="text-xl md:text-3xl font-serif-display text-white block tabular-nums tracking-tighter leading-none">
                      {item.value.toString().padStart(2, '0')}
                    </span>
                  </div>
                  <div className="flex flex-col items-center">
                    <span className="text-[6px] md:text-[8px] tracking-[0.2em] font-bold text-white/70 uppercase">
                      {item.label}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Minimal Date Label at Bottom */}
          <div className="absolute bottom-4 left-0 right-0 text-center px-4">
            <p className="text-[8px] md:text-[10px] tracking-[0.4em] font-bold text-white/40 uppercase">
              13.06.2026
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};